<template>
    <FilterBase :title="title">
        <ThSelect
            v-model="model"
            clearable
            :options="options"
            :default-value="null"
            :placeholder="'Any delivery timeframe'"
        />
    </FilterBase>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Bounds } from 'wucdbm-exponential-slider'

import FilterBase from '@/components/ui/filter/filters/layout/FilterBase.vue'
import ThSelect from '@/components/ui/inputs/ThSelect.vue'
import type { SelectOption } from '@/components/ui/inputs/th-select.ts'
import { useBounds } from '@/domain/stone'

interface Props {
    modelValue: number | null | undefined
    bounds: Bounds
    title?: string
    valueFormatter?: (value: number) => string
}

const props = withDefaults(defineProps<Props>(), {
    valueFormatter: undefined,
    title: 'Delivery days',
})

const emit = defineEmits({
    'update:modelValue': (v: number | null) => v,
})

const model = computed({
    get(): number | null {
        if (undefined === props.modelValue) {
            return null
        }

        return props.modelValue
    },
    set(v: number | null) {
        emit('update:modelValue', v)
    },
})

const boundsWithDefaults = useBounds(() => props.bounds, {
    min: 1,
    max: 30,
})

const options = computed((): SelectOption<number | null>[] => {
    const options: SelectOption<number | null>[] = []

    const bounds = boundsWithDefaults.value

    for (let i = bounds.min; i <= bounds.max; i++) {
        options.push({
            label: `Up to ${i} days`,
            value: i,
        })
    }

    return options
})
</script>
